import Backend from "./Backend";
import {selectedCompanyStore} from "../store/SelectedCompany";
import {UnitOfMeasurements} from "../model/invoice/UnitOfMeasurements";
import {TaxDto} from "../model/invoice/TaxDto";
import {ArticleDto} from "../model/invoice/ArticleDto";

class InvoiceApi {

    public fetchUOM(): Promise<UnitOfMeasurements[]> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/uom`);
    }

    public fetchTaxes(): Promise<TaxDto[]> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/tax`);
    }

    public fetchArticles(): Promise<ArticleDto[]> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/articles`);
    }
}

export const invoiceApi = new InvoiceApi();